<div mat-dialog-title>
  <su-headline h="h3" skin="primary">{{ data.title }}</su-headline>
  <div class="frozenZoneDescriptionContainer" *ngIf="hintDescription">
    <div
      class="sub-headline contactDescription frozenZoneDescription"
      [innerHtml]="hintDescription | safeHtml"></div>
  </div>
</div>

<div class="frozenZoneDescriptionContainer" *ngIf="data.frozenStatus">
  <div
    class="sub-headline contactDescription frozenZoneDescription"
    [innerHtml]="data.description | safeHtml"></div>
</div>

<div mat-dialog-content>
  <form [formGroup]="form" style="margin-top: 20px">
    <formly-form
      [form]="form"
      [fields]="formFields"
      [model]="formModel"></formly-form>
  </form>
</div>

<div mat-dialog-actions>
  <su-button
    skin="secondary"
    [label]="'crud.delete' | translate"
    (onClick)="onDelete()"
    [hidden]="!canDelete"></su-button>

  <su-button
    skin="secondary"
    [label]="'shared.cancel' | translate"
    mat-dialog-close></su-button>

  <su-button
    skin="primary"
    [label]="'shared.save' | translate"
    (onClick)="onSave()"
    [disabled]="!canSave"></su-button>
</div>

<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>
